// extracted by mini-css-extract-plugin
module.exports = {"introContent":"Comments_introContent__zOL0y","column":"Comments_column__npM5c","draft":"Comments_draft__YfO1d","comment":"Comments_comment__TroQg","meta":"Comments_meta__N4Txw"};
module.exports.__checksum = "6f29a55072d4"
